module.exports = __webpack_public_path__ + "img/tuurro.s10.p.ffde5adc.png";